import apiClient, { extractData } from "../api-client";

// Gửi in sang CMS in theo từng danh sách in (backend/app/api/cmsin.py).
// Không phải printJobApi — đó là hàng đợi in phiếu của xưởng.
export const cmsinApi = {
  list(orderId) {
    return apiClient.get(`/orders/${orderId}/cmsin`).then(extractData);
  },
  send(orderId, printKey) {
    return apiClient.post(`/orders/${orderId}/cmsin/${encodeURIComponent(printKey)}/send`).then(extractData);
  },
  // action: confirm | cancel | retry | refresh
  action(orderId, jobId, action) {
    return apiClient.post(`/orders/${orderId}/cmsin/jobs/${jobId}/${action}`).then(extractData);
  },
};
